import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import {
  NgxTippyProps
} from "ngx-tippy-wrapper";

export interface IntrestPageAnswer {
  defaultValue: string;
  defaultLabel: string;
  list: [];
}

@Component({
  selector: 'app-residency-selction-options',
  templateUrl: './residency-selction-options.component.html',
  styleUrls: ['./residency-selction-options.component.scss']
})
export class ResidencySelctionOptionsComponent implements OnInit {

  tippyPropsLeft = {
    placement: "top-start",
    arrow: false,
    theme: "light",
  };
  tippyProps = {
    placement: "top",
    arrow: true,
    theme: "light",
  };

  public baseProps: NgxTippyProps = {
    arrow: true,
    theme: "light"
  };
  @Input() options: any;
  @Input() pageAnswer: Map<string, IntrestPageAnswer>;
  @Input() disabledOption: Map<string, string>;

  @Input("index") index: string;
  @Input("placeholder") placeholder: string;
  selectValue: string = "";
  @Output() selectChange: EventEmitter<string> = new EventEmitter<string>();
  constructor() {}

  ngOnInit(): void {
    if (this.pageAnswer) {
      let SelectOption = this.pageAnswer.get(this.index);
      if (SelectOption != undefined) {
        if (this.placeholder == "Select Campus") {
          this.selectValue = SelectOption.defaultValue;
        }
      }
    }
  }


  setClass(value:string,option:string)
  {

    if(value==option)
    {
      return true;
    }
    else{

      return false;

    }


  }
  select(type: string, selectedvalue: string, value: string) {

    this.selectValue=selectedvalue;
    this.selectChange.emit(selectedvalue);
  }

  getOptionDisabled(val) {
    if (this.placeholder == "Select College") {
      if (this.disabledOption != undefined) {
        const ar = Array.from(this.disabledOption.values());
        if (ar.includes(val)) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  }

  ngOnChanges() {
    if (this.pageAnswer) {
      let SelectOption = this.pageAnswer.get(this.index);
    
      if(SelectOption)
      {

          if (this.placeholder == "Select Campus") {
            if (SelectOption.defaultValue != "") {
              this.selectValue = SelectOption.defaultValue;
            }
          }
        }
      }

  }
}